"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Block = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _container = _interopRequireDefault(require("../container"));

var _reactIntersectionObserver = require("react-intersection-observer");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styles = function styles(theme) {
  return {
    root: {},
    visible: {},
    container: {},
    noPadding: {
      padding: 0
    },
    small: {
      padding: theme.spacing(3, 0)
    },
    medium: {
      padding: theme.spacing(6, 0)
    },
    large: {
      padding: theme.spacing(9, 0)
    }
  };
};
/**
 * The Block component is used to create a distinct section on the page.  By default the Block component has the following styles applied:
 *
 * - 6 units (48px) of padding on the top / bottom of the block
 * - fluid width to fill the full width of the page (or parent element)
 * - content within the block follows the constraints of the Container component
 *
 * The root Block component is a [Material UI box](https://material-ui.com/components/box/) component, so all [box props](https://material-ui.com/components/box/#api) and [style props](https://material-ui.com/system/basics/#all-inclusive) are available.
 *
 * ## Classes
 *
 * Provide class names in the classes object with the following keys to override styles:
 *
 * - `root`: applied to the root element
 * - `visible`: applied to the root element when it is visible in the viewport
 * - `noPadding`: applied to the root when `noPadding` prop is true
 * - `small`: applied to the root when `small` prop is true
 * - `large`: applied to the root when `large` prop is true
 * - `container`: applied to the `<Container/>` element
 */


var Block = function Block(_ref) {
  var _clsx;

  var classes = _ref.classes,
      className = _ref.className,
      children = _ref.children,
      noPadding = _ref.noPadding,
      small = _ref.small,
      medium = _ref.medium,
      large = _ref.large,
      onVisibleChange = _ref.onVisibleChange,
      IntersectionOptions = _ref.IntersectionOptions,
      ContainerProps = _ref.ContainerProps,
      props = _objectWithoutProperties(_ref, ["classes", "className", "children", "noPadding", "small", "medium", "large", "onVisibleChange", "IntersectionOptions", "ContainerProps"]);

  // trigger events based on block visibility
  var _useInView = (0, _reactIntersectionObserver.useInView)(IntersectionOptions),
      ref = _useInView.ref,
      inView = _useInView.inView,
      entry = _useInView.entry; // check if padding props exist so we know if we should set default padding or not (default = medium)


  var boxPaddingProps = ["p", "pt", "pr", "pb", "pl", "px", "py"];
  var hasPaddingProps = small || large || noPadding || Object.keys(props).find(function (key) {
    return boxPaddingProps.indexOf(key) > -1;
  });
  (0, _react.useEffect)(function () {
    onVisibleChange && onVisibleChange(inView, entry);
  }, [inView]);
  return /*#__PURE__*/_react["default"].createElement(_core.Box, _extends({
    ref: ref,
    className: (0, _clsx2["default"])("HypBlock-root", classes.root, (_clsx = {
      "HypBlock-visible": inView,
      "HypBlock-noPadding": noPadding,
      "HypBlock-small": small,
      "HypBlock-large": large
    }, _defineProperty(_clsx, classes.visible, inView), _defineProperty(_clsx, classes.noPadding, noPadding), _defineProperty(_clsx, classes.small, small), _defineProperty(_clsx, classes.large, large), _defineProperty(_clsx, classes.medium, !hasPaddingProps || medium), _clsx), className)
  }, props), /*#__PURE__*/_react["default"].createElement(_container["default"], _extends({
    className: (0, _clsx2["default"])(classes.container)
  }, ContainerProps), children));
};

exports.Block = Block;
Block.defaultProps = {
  ContainerProps: {},
  IntersectionOptions: {}
};
Block.propTypes = {
  /**
   * Object with class name overrides (valid keys: `root`, `container`)
   */
  classes: _propTypes["default"].object,

  /**
   * Props to pass to the inner Container component
   */
  ContainerProps: _propTypes["default"].object,

  /**
   * Handler function for when the visibility of the block changes based on scroll position
   */
  onVisibleChange: _propTypes["default"].func,

  /**
   * Options passed to the `useInView` hook from [react-intersection-observer](https://github.com/thebuilder/react-intersection-observer#readme)
   */
  IntersectionOptions: _propTypes["default"].object,

  /**
   * Disables padding on the block
   */
  noPadding: _propTypes["default"].bool,

  /**
   * Use small padding preset
   */
  small: _propTypes["default"].bool,

  /**
   * use large padding preset
   */
  large: _propTypes["default"].bool
};
Block.__docgenInfo = {
  "description": "The Block component is used to create a distinct section on the page.  By default the Block component has the following styles applied:\n\n- 6 units (48px) of padding on the top / bottom of the block\n- fluid width to fill the full width of the page (or parent element)\n- content within the block follows the constraints of the Container component\n\nThe root Block component is a [Material UI box](https://material-ui.com/components/box/) component, so all [box props](https://material-ui.com/components/box/#api) and [style props](https://material-ui.com/system/basics/#all-inclusive) are available.\n\n## Classes\n\nProvide class names in the classes object with the following keys to override styles:\n\n- `root`: applied to the root element\n- `visible`: applied to the root element when it is visible in the viewport\n- `noPadding`: applied to the root when `noPadding` prop is true\n- `small`: applied to the root when `small` prop is true\n- `large`: applied to the root when `large` prop is true\n- `container`: applied to the `<Container/>` element",
  "methods": [],
  "displayName": "Block",
  "props": {
    "ContainerProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "Props to pass to the inner Container component"
    },
    "IntersectionOptions": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "Options passed to the `useInView` hook from [react-intersection-observer](https://github.com/thebuilder/react-intersection-observer#readme)"
    },
    "classes": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "Object with class name overrides (valid keys: `root`, `container`)"
    },
    "onVisibleChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Handler function for when the visibility of the block changes based on scroll position"
    },
    "noPadding": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Disables padding on the block"
    },
    "small": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Use small padding preset"
    },
    "large": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "use large padding preset"
    }
  }
};
var exportComponent = (0, _core.withStyles)(styles, {
  name: "HypBlock"
})(Block); // copy static props for storybook

if (process.env.NODE_ENV !== "production") {
  exportComponent.displayName = Block.displayName;
  exportComponent.propTypes = Block.propTypes;
  exportComponent.defaultProps = Block.defaultProps;
}

var _default = exportComponent;
exports["default"] = _default;